interface IBudgetObservationProps {
  observation?: string;
  onObservationChange?: (observation: string) => void;
  onRemoveObservation?: () => void;
}

const BudgetObservation = (props: IBudgetObservationProps) => {
  if (props.observation === undefined) {
    return null;
  }

  return (
    <div className="flex-1 mb-4">
      <div className="font-bold mb-2 text-size-12 text-gray-500">Observação</div>
      <div className="flex gap-2 items-start">
        <textarea
          className="form-control flex-1"
          rows={1}
          value={props.observation || ''}
          onChange={(e) => props.onObservationChange?.(e.target.value)}
        />
        <button
          type="button"
          className="cursor-pointer bg-transparent border-none p-0 mt-2 mr-8 ml-10"
          onClick={() => props.onRemoveObservation?.()}
        >
          <img src="/assets/images/bin.svg" alt="Excluir observação" className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default BudgetObservation;
